import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { WyanokeUtil } from "../../util/WyanokeUtil";
import { ViewBySpecialty } from "../news/ViewBySpecialty"

export class NewsLandingRedirect extends Component {

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
    }

    public async init(): Promise<void> {
        if (new URLSearchParams(window.location.search).get("showall") !== "1" &&
            (["/"].indexOf(window.location.pathname) !== -1
            || ["/news"].indexOf(window.location.pathname) !== -1
            || ["/news/resources"].indexOf(window.location.pathname) !== -1
            || ["/news/podcasts"].indexOf(window.location.pathname) !== -1
            || ["/news/blogs-and-columns"].indexOf(window.location.pathname) !== -1)) {
            await this.checkForRedirect();
        }
    }

    private async checkForRedirect(): Promise<void> {
        const context = this._pageContext;
        if (!context) {
            throw new Error("No page context");
        }

        const profile = await WyanokeUtil.loadUserProfile(true, false);

        if (profile) {
            let contentspecialty = profile.contentspecialty || '';
            if (contentspecialty === '' && profile.profession === 'Optometrist') {
                contentspecialty = 'optometry';
            }

            contentspecialty = contentspecialty.toLowerCase();
            if (contentspecialty === '' || contentspecialty == null) {
                return;
            }

            contentspecialty = contentspecialty.split("/").join("-").split(" & ").join("-").split("'").join("").split(" ").join("-").toLowerCase();
            const viewBySpecialty = context.componentFactory.getComponent<ViewBySpecialty>(ViewBySpecialty);

            let specialtySelect = viewBySpecialty?.element;
            if (specialtySelect) {
                specialtySelect.querySelectorAll<HTMLAnchorElement>("a[data-specialty-id]").forEach(function (elem) {
                    if(elem.href.includes(contentspecialty) && window.location.href != elem.href){
                        console.log("NewsLandingRedirect.ts: Redirecting to Users Specialty Page: " + window.location.href);
                        window.location.href = elem.href;
                        return;
                    }
                })
            }
        }
    }
}

ComponentFactory.registerComponent("NewsLandingRedirect", NewsLandingRedirect);
